<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12" width="600">
          <v-card-text class="text-center text-h5">
            <div style="margin-left:15px;margin-bottom: -25px;">
              <img style="width:200px" v-if="$vuetify.theme.dark" :src="assets('logos/bjjlink-2025-white.png')" />
              <img style="width:200px" v-else :src="assets('logos/bjjlink-2025-black.png')" />
            </div>
            <div>
              <img :src="assets('logos/admin-logo-pixelated.png')" style="width:100px" alt="Admin+">
            </div>
            <div>
              {{ $t("message.log_into_account") }}
            </div>
          </v-card-text>
          <v-card-text>
            <v-form>
              <v-text-field v-model="email" :rules="emailRules" prepend-icon="mdi-account" name="email" :label="'Email'"
                type="text"></v-text-field>
              <v-text-field v-model="password" v-on:keyup="captureEnter" id="password" prepend-icon="mdi-lock"
                :label="$t('message.password')" type="password"></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions class="mt-0 pt-0">
            <v-spacer></v-spacer>
            <span class="primary--text text-caption" @click="openForgotPasswordDialog()">
              <a>{{ $t("message.forgot_password") }}</a>
            </span>
          </v-card-actions>
          <v-card-text class="text-center error--text" v-if="this.error">
            <v-icon color="error" class="mr-1">mdi-alert-circle-outline</v-icon>
            {{ this.error }}
          </v-card-text>
          <v-card-actions>
            <v-btn outlined ref="loginButton" :loading="loggingIn" @click="login()" block elevation="0"
              color="primary">{{
                $t("message.login")
              }}</v-btn>
          </v-card-actions>
          <v-card-text class="text-center text-caption">
            {{ $t("message.dont_have_account") }}
            <span class="primary--text" @click="goToRegister()">
              <a>{{ $t("message.register") }}</a>
            </span>
          </v-card-text>
          <v-card-text class="text-center">
            <div class="text-subtitle-2">
              <p>{{ $t("message.powered_by") }}</p>
            </div>
            <div class="text-h6" style="margin-top:-10px">
              <img style="width:200px" v-if="$vuetify.theme.dark"
                :src="assets('logos/martial-arts-technology-white.png')" />
              <img style="width:200px" v-else :src="assets('logos/martial-arts-technology-black.png')" />
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="forgotPasswordDialogDialog" max-width="600px">
      <v-card outlined class="pa-2">
        <v-card-title>
          {{ $t('message.update_email_password') }}
        </v-card-title>
        <v-text-field dense outlined v-model="email" :rules="emailRules" prepend-icon="mdi-account-question-outline"
          :label="'Email'" type="text"></v-text-field>
        <v-card-actions>
          <v-btn outlined small elevation="0" color="primary" @click.stop="sendResetInstructions()">{{
            $t('message.send_instructions') }}</v-btn>
          <v-btn small elevation="0" @click.stop="forgotPasswordDialogDialog = false">{{
            $t('message.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import Api from "@/services/Api";

export default {
  data() {
    return {
      loggingIn: false,
      error: null,
      forgotPasswordDialogDialog: null,
      email: null,
      password: null,
      emailRules: [
        v => !!v || this.$t("message.required"),
        v =>
          /^(\s)*[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*(\s)*$/.test(v) ||
          this.$t("message.invalid_email")
      ],
    };
  },
  created() {
    this.setLang();
  },
  methods: {
    sendResetInstructions() {
      Api()
        .post(
          "recovery/forgot-password", {
          email: this.email.trim()
        })
        .then(() => {
          this.forgotPasswordDialogDialog = false;
          this.showAlert("success", this.$t('message.email_sent_to', [this.email]) + '. ' + this.$t('message.check_spam'));
        }).catch(() => {
          this.showAlert("error", this.$t("message.error_generic"));
        });
    },
    captureEnter(e) {
      if (e.keyCode === 13) {
        this.login();
      }
    },
    openBjjlinkInfo() {
    },
    openForgotPasswordDialog() {
      this.forgotPasswordDialogDialog = true;
    },
    goToRegister() {
      window.location = '/register';
    },
    login() {
      this.error = null;
      if (!this.email || !this.password) {
        this.error = this.$t("message.fill_all_params");
        return;
      }
      Api()
        .post(
          "users/login", {
          email: this.email.trim(),
          password: this.password
        })
        .then((response) => {
          if (response.data)
            this.processLoggedIn(response);
          else
            this.showAlert("error", this.$t("message.error_generic"));
        }).catch((err) => {
          if (err.response.status == 404)
            this.error = this.$t("message.invalid_user");
          else if (err.response.status == 400)
            this.error = this.$t("message.invalid_password");
          else this.error = this.$t("message.error_generic");
        });
    },
    processLoggedIn(response) {
      if (response.data.token) {
        this.$store.dispatch("setToken", response.data.token);
        this.$store.dispatch("setUser", response.data.user);
        this.$store.dispatch("setName", response.data.user.fName);
        this.$store.dispatch("setHidden", response.data.user.hidden);
        this.$store.dispatch("setInApp", false);

        this.$store.dispatch("setUserImage",
          (response.data.user.userImageSmall ?
            response.data.user.userImageSmall :
            response.data.user.userImage));
        this.$store.dispatch("setLanguage", response.data.user.lang);
        this.$i18n.locale = response.data.user.lang;
        localStorage.token = response.data.token;
        if (
          response.data.hasLatestAgreement &&
          response.data.hasLatestAgreement == true
        ) {
          localStorage.hasAgreements = true;
          this.$store.dispatch("setHasAgreements", true);
        } else {
          localStorage.hasAgreements = false;
          this.$store.dispatch("setHasAgreements", false);
        }
        window.location = process.env.VUE_APP_PUBLIC_PATH
      } else {
        this.error = this.$t("message.contact_support");
      }
    }
  },
  mounted() {
    this.$refs.loginButton.$el.focus();
  },
};
</script>

<style scoped></style>